export default __webpack_public_path__ + "static/media/46.39cc7fd4.jpg";